import React from "react";
import { Button, StatusIndicator } from "@amzn/awsui-components-react";
import { generatePromotionLink } from "../../helpers/linkUtils";
import { useMarketplaceId } from "../../contexes/MarketplaceIdContext";

interface PromotionStatusProps {
  promotionId?: string;
}

export function PromotionStatus({ promotionId }: PromotionStatusProps) {
  const { marketplaceId } = useMarketplaceId();

  if (!promotionId) {
    return <StatusIndicator type="stopped">No Promotions</StatusIndicator>;
  }

  if (marketplaceId) {
    const link = generatePromotionLink(promotionId, marketplaceId);
    return (
      <>
        <StatusIndicator type="success">Has Promotions</StatusIndicator>
        <Button
          href={link}
          target="_blank"
          rel="noopener noreferrer"
          iconName="external"
          variant="inline-icon"
          ariaLabel={`View promotion ${promotionId}`}
        />
      </>
    );
  }

  return <StatusIndicator type="success">Has Promotions</StatusIndicator>;
}
